// extracted by mini-css-extract-plugin
export default {"campaign_titleContainer":"Title_Subtitle_campaign_titleContainer__xGOiq","container":"Title_Subtitle_container__AWK3B","notes":"Title_Subtitle_notes__0k5cF"};